export default {
  DRIVETRAIN: "Motricité",

  DRIVETRAIN_AWD: "All-Wheel Drive (AWD)",
  DRIVETRAIN_4WD: "Four-Wheel Drive (4WD)",
  DRIVETRAIN_FWD: "Front-Wheel Drive (FWD)",
  DRIVETRAIN_RWD: "Rear-Wheel Drive (RWD)",
};
